import React from 'react'
import { Editable } from '@ui'
import { FormGroup, InputGroup, Intent } from '@blueprintjs/core'
import Label from './Label'

interface IProps {
  error?: string
  editing: boolean
  required?: boolean
  label: React.ReactNode
  value: any
  onChange: (val: any) => void
  type?: string
  'data-input'?: string
}

export default function Text({
  error,
  editing,
  required,
  label,
  value,
  onChange,
  type,
  'data-input': dataInput,
}: IProps) {
  const intent = error ? Intent.DANGER : undefined
  value = value || ''
  return (
    <>
      <Label {...{ editing, label, required }} />
      <Editable editing={editing}>
        <span>{value || '-'}</span>
        <FormGroup {...{ helperText: error, intent, style: { width: '100%' } }}>
          <InputGroup
            {...{
              value,
              onChange,
              intent,
              type,
              'data-input': dataInput,
            }}
          />
        </FormGroup>
      </Editable>
    </>
  )
}

export function Password({ ...props }: IProps) {
  return <Text {...props} type="password" />
}
